module.exports = "{{{base}}}\n<hr>\n<button class=\"wide launch-stylie\">Launch Tween Editor</button>\n"